import { PickingListCalculationRowShape } from '../../api/api_data_types'

const COLOR_CLASSES: Record<PickingListCalculationRowShape['color'], string> = {
  red: 'text-danger',
  orange: 'text-orange',
  green: 'text-success',
}

export default function pickingListColorClass(row: PickingListCalculationRowShape): string {
  return COLOR_CLASSES[row.color] || ''
}
